import { Heart } from "common/Heart";
import { Icon } from "common/LegacyIcon";
import React from "react";
import styles from "./SocialButtons.scss";

const fbUrl = () => `https://www.facebook.com/dialog/feed?
app_id=${window.rwgps.config.facebookAppId}&
link=${encodeURIComponent(window.location.href)}`;

const twitterUrl = () => `https://twitter.com/intent/tweet?
hashtags=RideReport&
text=${encodeURIComponent("Check out this great story: ")}&
url=${encodeURIComponent(window.location.href)}&
via=ridewithgps`;

export const SocialButtons = ({ liked, likesCount, onHeartClick }) => (
  <div className={styles.SocialButtons}>
    <ul>
      <li>
        <a className={styles.fbLink} target="_blank" href={fbUrl()}>
          <Icon i="circleFacebook" size={30} />
        </a>
      </li>
      <li>
        <a className={styles.twitterLink} target="_blank" href={twitterUrl()}>
          <Icon i="circleTwitter" size={30} />
        </a>
      </li>
      <li>
        <Heart liked={liked} count={likesCount} onClick={onHeartClick} />
      </li>
    </ul>
  </div>
);
